// Browser-profile signal only: never an authentication credential or hardware ID.
const COOKIE_NAME = "accountree_device_id";
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function readDeviceId() {
  const entry = document.cookie.split(";").map(value => value.trim())
    .find(value => value.startsWith(`${COOKIE_NAME}=`));
  const value = entry?.slice(COOKIE_NAME.length + 1);
  return value && UUID.test(value) ? value.toLowerCase() : null;
}

function createDeviceId() {
  const crypto = window.crypto;
  if (typeof crypto?.randomUUID === "function") return crypto.randomUUID();
  // Supports secure random IDs on HTTP development origins without randomUUID.
  if (typeof crypto?.getRandomValues !== "function") return null;
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, value => value.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getAccessMonitoringHeaders() {
  try {
    if (typeof window === "undefined" || typeof document === "undefined") return {};
    let deviceId = readDeviceId();
    if (!deviceId) {
      deviceId = createDeviceId();
      if (!deviceId || !UUID.test(deviceId)) return {};
      // Existing logout clears localStorage. A dedicated host-only cookie survives it.
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `${COOKIE_NAME}=${deviceId}; Path=/; Max-Age=15552000; SameSite=Lax${secure}`;
      // If persistence is blocked, omit the signal instead of inventing a new device every login.
      if (readDeviceId() !== deviceId.toLowerCase()) return {};
    }
    return { "X-Accountree-Device-Id": deviceId.toLowerCase() };
  } catch {
    // Browser privacy settings must not prevent login.
    return {};
  }
}

export function getLoginMonitoringHeaders() {
  const headers = getAccessMonitoringHeaders();
  // Each optional browser signal fails independently, without interrupting login.
  try {
    const language = navigator.language;
    if (language && language.length <= 30 && /^[a-zA-Z0-9-]+$/.test(language))
      headers["X-Accountree-Language"] = language;
  } catch { }
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (zone && zone.length <= 100 && /^[a-zA-Z0-9_+\-/]+$/.test(zone))
      headers["X-Accountree-TimeZone"] = zone;
  } catch { }
  try {
    const { width, height } = window.screen;
    if (Number.isInteger(width) && Number.isInteger(height) && width > 0 && height > 0
        && width < 100000 && height < 100000)
      headers["X-Accountree-Screen"] = `${width}x${height}`;
  } catch { }
  return headers;
}
